import commodityService from '@planning/services/commodityService'
import { AutocompleteViewStore } from '../autocomplete/AutocompleteViewStore'

//TODO Change the entity
export class CommodityAutocompleteViewStore extends AutocompleteViewStore<any> {
  constructor() {
    super(() => commodityService.getByPartialName(this.filter))
  }
}
